import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { graphql, readFragment } from "@opensea/graphql";
import { EM_DASH } from "@opensea/i18n";
import { FlexCenter, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { ArrowRightAlt } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../../../../components/Avatar";
import { useSwapCurrencies, useSwapCurrenciesFragment } from "../../../hooks/useSwapCurrencies";
export const SwapDetailsNetworkItemFragment = graphql(`
    fragment SwapDetailsNetworkItem on SwapRouteResult {
      ...useSwapCurrencies
    }
  `, [useSwapCurrenciesFragment]);
export function SwapDetailsNetworkItem(t0) {
  const $ = _c(17);
  const {
    swapRoute: swapRouteKey
  } = t0;
  let t1;
  if ($[0] !== swapRouteKey) {
    t1 = readFragment(SwapDetailsNetworkItemFragment, swapRouteKey);
    $[0] = swapRouteKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const swapRoute = t1;
  const t = useTranslations("wallet.SwapDetailsNetworkItem");
  let t2;
  if ($[2] !== swapRoute) {
    t2 = {
      swapRoute
    };
    $[2] = swapRoute;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    fromAsset,
    toAsset
  } = useSwapCurrencies(t2);
  const isBridge = fromAsset && toAsset && fromAsset.chainIdentifier !== toAsset.chainIdentifier;
  const {
    getName: getChainName,
    getLogo: getChainLogo
  } = useChains();
  let t3;
  if ($[4] !== t) {
    t3 = t("network");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TextBody>{t3}</TextBody>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fromAsset || $[9] !== getChainLogo || $[10] !== getChainName || $[11] !== isBridge || $[12] !== toAsset) {
    t5 = isBridge ? <FlexCenter className="gap-2"><FlexCenter className="gap-1.5"><Avatar {...getChainLogo(fromAsset.chainIdentifier, {
          circle: true
        })} size={20} /><TextBody>{getChainName(fromAsset.chainIdentifier)}</TextBody></FlexCenter><ArrowRightAlt size={20} /><FlexCenter className="gap-1.5"><Avatar {...getChainLogo(toAsset.chainIdentifier, {
          circle: true
        })} size={20} /><TextBody>{getChainName(toAsset.chainIdentifier)}</TextBody></FlexCenter></FlexCenter> : fromAsset ? <FlexCenter className="gap-1.5"><Avatar {...getChainLogo(fromAsset.chainIdentifier, {
        circle: true
      })} size={20} /><TextBody>{getChainName(fromAsset.chainIdentifier)}</TextBody></FlexCenter> : <TextBody>{EM_DASH}</TextBody>;
    $[8] = fromAsset;
    $[9] = getChainLogo;
    $[10] = getChainName;
    $[11] = isBridge;
    $[12] = toAsset;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <SpaceBetween>{t4}{t5}</SpaceBetween>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}